import { Injectable, OnInit } from '@angular/core';
import { Subscription, Subject } from 'rxjs';

interface ToolbarSettings {
  orientation: 'vertical' | 'horizontal';
  lastPosition: { x: number; y: number } | null;
}

@Injectable()
export class ToolbarSettingsService implements OnInit {
  private storage: Storage = localStorage;
  private subjects = {
    lastPosition: new Subject(),
  };

  ngOnInit(): void {
    this.subjects.lastPosition.next(this.getJSONSetting('lastPosition'));
  }

  subscribe<T>(name: keyof ToolbarSettings, callback: (value: T) => unknown): Subscription {
    let subject = this.subjects[name];

    if (!subject) {
      subject = new Subject();
      this.subjects[name] = subject;
    }

    return subject?.subscribe(callback);
  }

  getSetting(name: string, fallback?: string): string {
    return this.storage.getItem(`toolbar.${name}`) ?? fallback;
  }

  getJSONSetting(name: string) {
    return JSON.parse(this.getSetting(name, 'null'));
  }

  getBooleanSetting(name: string): boolean {
    return this.getJSONSetting(name) ?? false;
  }

  setSetting(name: string, value: string): string {
    this.storage.setItem(`toolbar.${name}`, value);

    return value;
  }

  setJSONSetting<T>(name: string, value: T): T {
    this.setSetting(name, JSON.stringify(value));

    return value;
  }

  setBooleanSetting(name: string, value: boolean): boolean {
    this.setSetting(name, value ? 'true' : 'false');
    this.subjects[name]?.next(value);

    return value;
  }

  toggleBooleanSetting(name: string): boolean {
    return this.setBooleanSetting(name, !this.getBooleanSetting(name));
  }
}
